import { QuizAppRouteNames } from '@/routes/constants/location'
import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../auth'


const QuizRoot = () =>
  import('@/pmd/pages/marketing/QuizRoot.vue').then(m => m.default)
const QuizBuilderListPage = () =>
  import(
    /* webpackChunkName: "m-form-builder" */ '@/pmd/pages/marketing/QuizBuilderPageList.vue'
  ).then(m => m.default)
const QuizSubmissionPage = () =>
  import('@/pmd/pages/marketing/QuizSubmissionPage.vue').then(m => m.default)


export const QuizBuilderRoutes: RouteConfig[] = [
  {
    path: 'quiz-builder',
    name: QuizAppRouteNames.default,
    component: QuizRoot,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'main',
        name: QuizAppRouteNames.main,
        component: QuizBuilderListPage,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: 'submissions',
        name: QuizAppRouteNames.submissions,
        component: QuizSubmissionPage,
        beforeEnter: (to, from, next) => {
          requireAuthAndLocation(to, from, () => {
            sessionStorage.removeItem('store')
            next()
          })
        },
      },
    ],
  },
]
